module.exports = [
  {
    id: 'condition',
    chapters: [
      {
        title: 'introduction'
      }, {
        title: 'condition_overview',
        subchapters: [
          {
            title: 'overview'
          }
        ]
      }, {
        title: 'references'
      }
    ]
  }, {
    id: 'procedure',
    chapters: [
      {
        title: 'introduction'
      }, {
        title: 'procedure_overview',
        subchapters: [
          {
            title: 'overview'
          }
        ]
      }, {
        title: 'references'
      }
    ]
  }
];
